import React from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import { PrismicRichText } from "@prismicio/react";
import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";

const Reason = ({ title, desc, icon }) => {
  const item = {
    show: { opacity: 1, y: 0, transition: { duration: 0.3 } },
    hide: { opacity: 0, y: 0, transition: { duration: 0.3 } },
  };
  return (
    <motion.div
      className="flex flex-col md:px-16 px-2 md:justify-start mb-6 md:mb-12"
      variants={item}
    >
      <div className="mr-3">
        <div className="h-8 w-8 flex-none">
          <GatsbyImage image={icon} />
        </div>
      </div>
      <div>
        <h5 className="text-blue-dark mb-1 md:text-xl lg:text-2xl">{title}</h5>
        <div className="max-w-xl md:max-w-sm lg:max-w-xs">
          <PrismicRichText field={desc} />
        </div>
      </div>
    </motion.div>
  );
};

export default function Reasons({ slice }) {
  const { ref, inView } = useInView({
    threshold: 0.5,
    triggerOnce: false,
  });

  const variants = {
    show: { opacity: 1, transition: { duration: 0.8, staggerChildren: 0.15 } },
    hide: { opacity: 0, transition: { duration: 0.8 } },
  };

  //   const scheduleCta = data.prismicHomepage.data["schedule_cta"].text
  return (
    <div className="">
      <div className=" md:mb-12 lg:mb-28 relative bg-blue-light z-10 px-4 md:px-8 flex flex-col md:flex-row md:justify-center  py-8 md:py-28">
        <div className="w-80 -mt-1 mb-8 md:mb-0 self-center md:self-stretch lg:self-center">
          <GatsbyImage
            image={slice.primary.reason_image.gatsbyImageData}
            alt={slice.primary.reason_image.alt}
          />
        </div>
        <div className="flex flex-col">
          <motion.div
            className="flex flex-col mb-auto"
            variants={variants}
            animate={inView ? "show" : "hide"}
            initial="hide"
            ref={ref}
          >
            {slice.items.map(
              ({ reason_description, reason_title, icon }, index) => (
                <Reason
                  icon={icon.gatsbyImageData}
                  title={reason_title.text}
                  desc={reason_description.richText}
                  key={index}
                />
              )
            )}
          </motion.div>
          {/* <div className=" flex md:pl-16 self-center md:self-stretch">
            <Link
              to="/contact"
              className="hoverShadow text-base font-semibold pb-3 pt-2 mr-6 px-7 bg-blue text-white rounded-full"
            >
              {scheduleCta}
            </Link>
          </div> */}
        </div>
      </div>
    </div>
  );
}
